const { windowLoaded } = await import(`./modules/general.js?ver=${paths.cachebuster}`);
const { initMenu } = await import(`./modules/menu.js?ver=${paths.cachebuster}`);
const { initBuilder } = await import(`./modules/builder.js?ver=${paths.cachebuster}`);

async function main() {
  await windowLoaded();

  try {
    initMenu();
    initBuilder();
    initImagesAnimation();
  } catch (err) {
    console.error(err);
  }
}

main();

function initImagesAnimation() {
  // First row
  let lastScrollTop = 0;
  if (window.innerWidth > 640) {
    window.addEventListener('scroll', () => {
      var st = window.pageYOffset || document.documentElement.scrollTop;

      document.querySelectorAll('header .images .col').forEach((Col) => {
        var Index = Array.prototype.indexOf.call(Col.parentNode.children, Col),
          style = window.getComputedStyle(Col),
          matrix = new DOMMatrixReadOnly(style.transform),
          y = parseFloat(matrix.m42);

        if (st > lastScrollTop) {
          y = y + 0.2;
        } else if (st < lastScrollTop) {
          y = y - 0.2;
        }

        if (Index == 2 || Index == 4) {
          Col.style.transform = 'translateY(' + y + 'px)';
        } else {
          Col.style.transform = 'translateY(-' + y + 'px)';
        }
      });

      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    });
  }
}
